import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Badge, Button } from '@mui/material'
import { useFormState, useWatch } from 'react-hook-form'
import useModals from 'src/Hooks/useModals'
import { useInstallationForm } from 'src/Libs/flow/installation/hooks'
import { DirtyMark } from 'src/Libs/flow/icons'
import { useInstallationAccessRightsContext } from 'src/Libs/installation-rights-management/provider/InstallationAccessRightsContext'
/**
 * Button component to open a dialog for entering the OCPP password for 'CarAtHome'-Feature.
 * @param index Index of the evse-object in the evse-list
 */
export const OcppPasswordField: React.FC<{ index: number }> = ({ index }) => {
  const { t } = useCustomTranslation()
  const { control, setValue } = useInstallationForm()
  const { hasInstallationWritingRights: canEdit } = useInstallationAccessRightsContext()
  const { dirtyFields } = useFormState({
    control,
    name: `chargingStations.modbusTcp.${index}.carAtHomeBehavior.password`,
  })

  const isPasswordDirty = !!dirtyFields.chargingStations?.modbusTcp?.[index]?.carAtHomeBehavior?.password

  const { openEnterOcppPasswordDialog } = useModals()

  const installationId = useWatch({ control, name: 'id' })

  const modbusTcp = useWatch({ control, name: `chargingStations.modbusTcp.${index}` })

  const emcId = modbusTcp.rawData?.deviceLinkId?.toString() ?? ''
  const modbusTcpId = modbusTcp.deviceId ?? ''

  const canUpdatePassword = installationId !== null && emcId && modbusTcpId

  const handleClick = (): void => {
    if (!canUpdatePassword) return

    const setPassword = (password: string): void => {
      setValue(`chargingStations.modbusTcp.${index}.carAtHomeBehavior.password`, password, {
        shouldDirty: true,
      })
    }

    openEnterOcppPasswordDialog({ setPassword })
  }

  return (
    <Badge sx={{ width: '100%' }} color="secondary" badgeContent={isPasswordDirty ? <DirtyMark inheritColor /> : null}>
      <Button
        size="large"
        variant="outlined"
        color="secondary"
        onClick={handleClick}
        disabled={!canUpdatePassword || !canEdit}
        sx={{ whiteSpace: 'nowrap' }}
        fullWidth
      >
        {t('installation.evseEditor.carAtHome.passwordConfig.buttonTitleEnterPwd')}
      </Button>
    </Badge>
  )
}
